/* eslint-disable react/no-unknown-property */
import { array, object } from "prop-types";
import { Link, ResponsiveImage } from "@quintype/components";
import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";

import { MenuItem } from "../../../layouts/menu-item";

import "./section-menu.m.css";

const SectionMenu = ({ sections, section, collection }) => {
  const collectionBanner = get(collection, ["metadata", "cover-image", "cover-image-s3-key"]);
  const collectionBannerAttribution = get(collection.metadata, ["cover-image", "attribution"]);

  const getParentId = () => {
    const parentID = get(section, ["parent-id"]);
    if (!parentID) {
      return get(section, ["id"]);
    }

    const parentSection = sections.find((item) => item.id === section["parent-id"]);
    return parentSection.id;
  };

  const getParentSection = () => {
    const parentSection = sections.find((item) => item.id === getParentId());

    return (
      <Link href={get(parentSection, ["section-url"])} aria-label="parent section">
        {get(parentSection, ["display-name"]) || get(parentSection, ["name"]) || get(collection, ["name"])}
      </Link>
    );
  };

  const getChildSections = () => {
    const parentSection = sections.find((item) => item.id === getParentId());
    const parentSectionSlug = get(parentSection, ["slug"]);
    const subSectionSlug =
      parentSectionSlug === get(section, ["slug"])
        ? `${get(section, ["slug"])}`
        : `${parentSectionSlug}/${get(section, ["slug"])}`;
    const menuList = useSelector((state) => get(state, ["qt", "config", "layout", "menu"], []));

    const sectionMenuList =
      menuList &&
      menuList.filter((item) =>
        parentSectionSlug !== get(section, ["slug"])
          ? item["menu-group-slug"] === parentSectionSlug
          : item["menu-group-slug"] === parentSectionSlug ||
            item["menu-group-slug"] === get(section, ["slug"]) ||
            get(item, ["menu-group-slug"]) === collection.slug
      );

    const subSectionMenuList = menuList && menuList.filter((item) => item["menu-group-slug"] === subSectionSlug);

    if ((subSectionMenuList && subSectionMenuList.length > 0) || (sectionMenuList && sectionMenuList.length > 0)) {
      return (
        <div styleName="child-sections-wrapper" data-test-id="child-sections-wrapper">
          {(subSectionMenuList.length < 1 ? sectionMenuList : subSectionMenuList).map((item, index) => {
            const customStyleName = index !== sectionMenuList.length - 1 ? "section-with-divider" : "";
            const url = new URL(item.url);
            item.completeUrl = url.pathname;
            return (
              <div
                styleName={`child-section ${customStyleName} child-menu`}
                key={item.id}
                data-test-id="child-sections"
              >
                <MenuItem menuStyle="menu-link" item={item} />
              </div>
            );
          })}
        </div>
      );
    }

    if (!section) {
      return null;
    }
    const childSections = sections && sections.filter((item) => item["parent-id"] === getParentId());

    if (!childSections || childSections.length < 1) {
      return null;
    }
    return (
      <div styleName="child-sections-wrapper" data-test-id="child-sections-wrapper">
        {childSections.map((item, index) => {
          const customStyleName = index !== childSections.length - 1 ? "section-with-divider" : "";

          return (
            <div styleName={`child-section ${customStyleName}`} key={item.id} data-test-id="child-sections">
              <Link
                href={item["section-url"]}
                style={{
                  "font-weight": item.id === section.id ? "700" : "400",
                  color: "#202020",
                }}
                aria-label="child section"
              >
                {item["display-name"] || item.name}
              </Link>
            </div>
          );
        })}
      </div>
    );
  };

  const CollectionBannerComponent = (name) => {
    if (collectionBanner) {
      return (
        <figure styleName="collection-banner-figure">
          <ResponsiveImage
            slug={collectionBanner}
            metadata={collection.metadata}
            imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
            alt={collectionBannerAttribution || ""}
          />
        </figure>
      );
    }
    return <h2 styleName="parent-section">{name}</h2>;
  };

  return (
    <div>
      {CollectionBannerComponent(getParentSection())}
      {getChildSections()}
    </div>
  );
};

SectionMenu.propTypes = {
  sections: array,
  section: object,
  collection: object,
};

export default SectionMenu;
